import { render, staticRenderFns } from "./ErroView.vue?vue&type=template&id=55310a3b&scoped=true"
import script from "./ErroView.vue?vue&type=script&lang=js"
export * from "./ErroView.vue?vue&type=script&lang=js"
import style0 from "./ErroView.vue?vue&type=style&index=0&id=55310a3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55310a3b",
  null
  
)

export default component.exports